// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"107":"23ddf314872840aed595","168":"290c1105adec33ebca56"}[chunkId] + ".js";
};